import Colors from '@/constants/Colors';
import styled from 'styled-components';
const cardHeight = 91;

export const StyledLiveTaskCard = styled.div`
  height: ${cardHeight}px;
  width: 100%;
  background: white;
  border-radius: 6px;
  padding: 5px 5px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: fade-in 0.8s;
  position: relative;

  border: 1px solid ${Colors.border};
  box-shadow: 0px 1px 4px ${Colors.boxShadowGray};
  transition: all 0.2s ease-in-out;

  ${(props) => props.selected && `border: 1px solid ${Colors.primary};`}

  :hover {
    color: ${Colors.primary};
    border: 1px solid ${Colors.primary};
    cursor: pointer;
    box-shadow: 0px 1px 4px ${Colors.primary}99;
  }

  .task-thumb {
    position: relative;
    margin: 5px;
    width: calc(${cardHeight}px - 10px);
    height: calc(${cardHeight}px - 10px);
    border-radius: 6px;
    overflow: hidden;
    img {
      object-fit: cover;
    }
  }

  .task-info {
    padding-left: 5px;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .task-title {
      font-weight: bold;
    }
  }
`;
